import React from "react";
import I18n from "../../../../commons/I18n/I18n";
import VehicleBrand from "../../../../commons/model/VehicleBrand";
import { generateRoute } from "../../../../commons/utils/Router";
import Th from "../../../../components/table/Th";
import I18nKeys from "../../../../I18n/I18nKeys";
import { ROUTE_ADMIN_VEHICLE_BRAND_DETAIL } from "../../../../routing/Routes";
import { goToRoute } from "../../../../utils/Router";
import { OnSortHandler, SortState } from "../../../../utils/Sort";

interface VehicleBrandListTableProps {
    data: VehicleBrand[];
    error: string;
    onSort: OnSortHandler;
    sort: SortState;
    renderSelectTd?: (itemId: string)=> React.ReactNode;
}

const goToItemDetail = (itemId: string): void => {
  goToRoute(generateRoute(ROUTE_ADMIN_VEHICLE_BRAND_DETAIL, {
    id: itemId,
  } ));
};

export default class VehicleBrandListTable extends React.Component<VehicleBrandListTableProps> {
  public render(): React.ReactNode {
    const {data, renderSelectTd} = this.props;

    return (
      <table className="table table-hover">
        <thead>{this.renderTH()}</thead>
        <tfoot>{this.renderTH()}</tfoot>
        <tbody>
          {data && data.map((vehicleBrand: VehicleBrand) => (
            <tr key={vehicleBrand.id}
              onClick={() => goToItemDetail(vehicleBrand.id)}
              className={"tr-cursor"}
            >
              {renderSelectTd ? renderSelectTd(vehicleBrand.id) : null}
              <td>
                {vehicleBrand.id}
              </td>
              <td>
                {vehicleBrand.name}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    );
  }

  private renderTH(): React.ReactNode {
    const {sort, children, onSort} = this.props;
    const commonProps = {
      sort,
      onSort,
    };

    return (
      <tr>
        {children}
        <Th text={I18n.tr(I18nKeys.IDENTIFICADOR)}
          columnName={"id"}
          {...commonProps}
        />
        <Th text={I18n.tr(I18nKeys.NOMBRE)}
          columnName={"name"}
          {...commonProps}
        />
      </tr>
    );
  }
}
